export default __webpack_public_path__ + "static/media/hp android.0a9de469.png";